import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true, timeout: 20000 });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("s3d_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const fileUrl = (path) => `${API}/files/${path}`;

export const STATUSES = ["In attesa", "In lavorazione", "In stampa", "In colorazione", "Completato", "Consegnato"];

export const SERVICES = ["Stampa 3D", "Incisione Laser"];

export const STATUS_COLORS = {
  "In attesa": "#FFE600",
  "In lavorazione": "#FF9500",
  "In stampa": "#00F0FF",
  "In colorazione": "#FF007F",
  "Completato": "#39FF14",
  "Consegnato": "#A855F7",
};
